import { CompanyQualitySelector } from "./components/CompanyQualitySelector";

import { QuestionComponentProps } from "@otta/search/containers/Quiz";
import { UserCvParsingStatusDocument } from "@otta/search/schema";
import { useQuery } from "@otta/search/apollo";
import { Spinner } from "@otta/search/components/Loading";
import { useExperiment } from "@otta/search/hooks/unleash";
import { Experiment } from "@otta/search/constants/experiments";

export function CompanyQuality({
  setNextEnabled,
  setShowNegative,
}: QuestionComponentProps): React.ReactElement {
  const { data, loading } = useQuery(UserCvParsingStatusDocument);
  const { variant: CvSignupVariant } = useExperiment(Experiment.CVSignup);
  const CvSignupEnabled = CvSignupVariant === "variant";

  if (loading) {
    return <Spinner />;
  }

  const cvUploaded = ["COMPLETED", "FAILED"].includes(
    data?.currentUser?.cvParsingStatus || ""
  );

  return (
    <CompanyQualitySelector
      onPreferenceSet={(isPreferenceSet: boolean) => {
        setNextEnabled?.(isPreferenceSet);
        if (CvSignupEnabled) {
          setShowNegative?.(!cvUploaded);
        } else {
          setShowNegative?.(false);
        }
      }}
    />
  );
}
